export const pluralOrSingular = (counts: number): string => {
  if (counts === 1) return "";
  return "s";
};
